import request from '../utils/request'

/**
 * 机器人相关API
 */

// 获取机器人列表（不分页）
export function getRobotList(params) {
  return request({
    url: '/robot/list',
    method: 'get',
    params
  })
}

// 获取机器人列表（分页）
export function getRobotListPaged(params) {
  return request({
    url: '/robot/list/paged',
    method: 'get',
    params
  })
}

// 获取机器人详情
export function getRobotDetail(id) {
  return request({
    url: `/robot/${id}`,
    method: 'get'
  })
}

// 创建机器人
export function createRobot(data) {
  return request({
    url: '/robot',
    method: 'post',
    data
  })
}

// 更新机器人
export function updateRobot(id, data) {
  return request({
    url: `/robot/${id}`,
    method: 'put',
    data
  })
}

// 删除机器人
export function deleteRobot(id) {
  return request({
    url: `/robot/${id}`,
    method: 'delete'
  })
}

// 修改机器人状态（启用/禁用）
export function changeRobotStatus(id, data) {
  return request({
    url: `/robot/${id}/status`,
    method: 'patch',
    data
  })
}

// 更新机器人实时状态
export function updateRobotRealtimeStatus(id, data) {
  return request({
    url: `/robot/${id}/realtime-status`,
    method: 'patch',
    data
  })
}

// 获取机器人实时状态
export function getRobotRealtimeStatus(id) {
  return request({
    url: `/robot/${id}/realtime-status`,
    method: 'get'
  })
}

// 机器人心跳上报
export function robotHeartbeat(id) {
  return request({
    url: `/robot/${id}/heartbeat`,
    method: 'post'
  })
}

// 获取在线机器人列表
export function getOnlineRobotList() {
  return request({
    url: '/robot/online',
    method: 'get'
  })
}

// 更新机器人账号
export function updateRobotAccount(id, data) {
  return request({
    url: `/robot/${id}/account`,
    method: 'put',
    data
  })
}

// 根据账号获取机器人信息
export function getRobotByAccount(robotAccount) {
  return request({
    url: '/robot/account/' + robotAccount,
    method: 'get'
  })
}

// 获取机器人头像
export function getRobotAvatar(robotId) {
  return request({
    url: `/robot/${robotId}/avatar`,
    method: 'get'
  })
}

// 获取机器人数字人视频
export function getRobotVideo(robotId) {
  return request({
    url: `/robot/${robotId}/video`,
    method: 'get'
  })
}

export default {
  getRobotList,
  getRobotListPaged,
  getRobotDetail,
  createRobot,
  updateRobot,
  deleteRobot,
  changeRobotStatus,
  updateRobotRealtimeStatus,
  getRobotRealtimeStatus,
  robotHeartbeat,
  getOnlineRobotList,
  updateRobotAccount,
  getRobotByAccount,
  getRobotAvatar,
  getRobotVideo
}
